export default function DevBuddySupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support - DevBuddy
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, common answers, and contact details for DevBuddy users.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                What is DevBuddy?
              </h3>
              <p className="mt-1">
                DevBuddy is a developer toolkit app with utilities for JSON,
                Regex, Base64, UUID, JWT, SQL, YAML, XML, QR codes, token
                counting, timestamps, and more.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Does DevBuddy work offline?
              </h3>
              <p className="mt-1">
                Yes. Most tools are designed to work locally on your device
                without sending your input data to external servers.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I use a tool?
              </h3>
              <p className="mt-1">
                Open the tool you need, paste or type your input, then tap the
                primary action such as Format, Encode, Decode, Generate, or
                Validate.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why do I see ads?
              </h3>
              <p className="mt-1">
                Some versions of the app may show ads to support development.
                Ad behavior can vary by platform, release, and configuration.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I report a bug or request a feature?
              </h3>
              <p className="mt-1">
                Email support with your device model, OS version, app version,
                the tool you used, and steps to reproduce the issue.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Support</h2>
          <p>
            If you need help, want to report a bug, or have feedback about the
            app, contact us at{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We typically respond within 24-48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Useful Links</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Privacy Policy:</strong>{" "}
              <a
                href="https://cosmovexapps.com/apps/devbuddy/privacy-policy"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/apps/devbuddy/privacy-policy
              </a>
            </li>
            <li>
              <strong>Support URL:</strong>{" "}
              <a
                href="https://cosmovexapps.com/apps/devbuddy/support"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/apps/devbuddy/support
              </a>
            </li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>App Name:</strong> DevBuddy
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact Email:</strong>{" "}
              <a
                href="mailto:trionapps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                trionapps@gmail.com
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
